/**
 * @description Suffix for Parent nav link in subnav based on locale
 *
 * @returns {string} Suffix
 */
function getHomeLinkSuffix(locale) {
  if (!locale || locale === 'en') {
    return 'Home';
  }
  return 'Inicio';
}

/**
 * @description prepends the MLB AWS URL, locale and/or slug to a URL
 *
 * @param {string} [link='']
 * @param {string} [teamNameSlug='']
 * @param {string} [locale='en']
 * @returns a URL string
 */
function getContextualUrl() {
  var link = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var teamNameSlug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en';
  var RE_ABSOLUTE_URL = /^#|\/\/|[a-z][a-z0-9+.-]*:/;
  if (!link || RE_ABSOLUTE_URL.test(link)) {
    return link;
  }
  var url = link;
  url = teamNameSlug && "/".concat(teamNameSlug).concat(url) || url;
  url = locale && locale !== 'en' && "/".concat(locale).concat(url) || url;
  return url;
}

/**
 * @description Slugify a string by replacing spaces with hyphens (-)
 *
 * @param {string} [text] Raw string
 * @returns Modified string
 */
function slugify(text) {
  if (!text || typeof text !== 'string') {
    return '';
  }
  return text.toLowerCase().split(' ').filter(Boolean).join('-');
}

/**
 * @description Gets Viewport width of Browser window
 *
 * @returns {number} Current Width
 */
function getWindowWidth() {
  return window && window.innerWidth || document && document.documentElement.clientWidth || document && document.body.clientWidth;
}

/**
 * @description Gets Viewport Height of Browser window
 *
 * @returns {number} Current Height
 */
function getWindowHeight() {
  return window && window.innerHeight || document && document.documentElement.clientHeight || document && document.body.clientHeight;
}

/**
 * @description Gets default icon for sections
 *
 * @param {string} [text] Raw string
 * @returns {string} Name of icon
 */
function getDefaultIcon(name) {
  var iconDefaultMap = {
    ballpark: 'gameday',
    community: 'globe',
    espanol: 'es',
    locale: 'globe',
    players: 'group',
    playball: 'baseball',
    roster: 'group',
    schedule: 'calendar',
    scores: 'line-score',
    shop: 'shopping-cart'
  };
  return iconDefaultMap[name] || name;
}
export { getContextualUrl, getDefaultIcon, getWindowHeight, getWindowWidth, getHomeLinkSuffix, slugify };